import { z } from 'zod';

export const AbstractMeasurement = {
    value: z.object({
        value: z.number().nullable().default(null),
        unit: z.string(),
    }),
    // A nominal `nom` with an OPTIONAL operating-condition spread: `min`/`max` are
    // omitted entirely when unset, so a plain `{nom, unit}` measurement stays minimal
    // (see the Capacitance/Resistance/Inductance tests asserting `'min' in x === false`).
    // Used by the DEV-9187 range measurements (capacitance, ESR/resistance, inductance).
    // The fault engine reads `min`/`max` and falls back to `nom`; existing `{value, unit}`
    // data is converted to `{nom, unit}` by a Payload migration.
    // Differs from `minNomMax` below only in that there min/max are always present (null
    // by default) rather than optional.
    nomOptionalMinMax: z.object({
        nom: z.number().nullable().default(null),
        min: z.number().nullable().optional(),
        max: z.number().nullable().optional(),
        unit: z.string(),
    }),
    minNom: z.object({
        min: z.number().nullable().default(null),
        nom: z.number().nullable().default(null),
        unit: z.string(),
    }),
    minMax: z.object({
        min: z.number().nullable().default(null),
        max: z.number().nullable().default(null),
        unit: z.string(),
    }),
    // A full min/nom/max range where all three endpoints are first-class and always
    // present (null when unset). Used by voltage, frequency and power. Contrast with
    // `nomOptionalMinMax` above, where min/max are optional and omitted when unset.
    minNomMax: z.object({
        min: z.number().nullable().default(null),
        nom: z.number().nullable().default(null),
        max: z.number().nullable().default(null),
        unit: z.string(),
    }),
    nom: z.object({
        nom: z.number().nullable().default(null),
        unit: z.string(),
    }),
    nomMax: z.object({
        nom: z.number().nullable().default(null),
        max: z.number().nullable().default(null),
        unit: z.string(),
    }),
};
